import type { Theme } from "@mui/material";

export default (theme: Theme) => {
  const responsiveField = {
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: "100%",
    },
  };

  return {
    section: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginLeft: 0,
      marginRight: 0,
      padding: "0 2.5rem 0 7rem",
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap",
        padding: 0,
      },
    },

    newsletter: {
      margin: "0.5rem 0 0 0",
      ...responsiveField,
    },
    tos: {
      margin: 0,
      ...responsiveField,
    },
  };
};
